module.exports = __webpack_public_path__ + "assets/abstract-bg-4.c4d8c2f3.svg";